exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-add-button[data-v-5d76b552]{height:50px}", ""]);

// exports
